import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['submit', 'select']

  connect() {
    this.BASE_USER_PERMISSIONS_URL = '/sandbar/admin/users/'
  }

  selectionInvaild() {
    const selected_value = this.selectTarget.value
    return !selected_value || selected_value.length === 0
  }

  handleSelect() {
    if (this.selectionInvaild()) {
      this.submitTarget.disabled = true;
    } else {
      this.submitTarget.disabled = false;
    }
  }

  handleSubmit() {
    if (this.selectionInvaild()) return

    let user_id = this.submitTarget.dataset.userId;
    let owner_id = this.selectTarget.value;
    this.submitTarget.text = 'Please Wait...';
    window.location.href = this.buildURL(user_id, owner_id);
  }

  buildURL(user_id, owner_id) {
    return `${this.BASE_USER_PERMISSIONS_URL}${user_id}/permissions/${owner_id}`
  }
}
